import {BaseModel} from '../_base/crud';

export const SPACE_TYPE_NO = 0;
export const SPACE_TYPE_SUUMO = 1;
export const spaceTypes = [SPACE_TYPE_NO, SPACE_TYPE_SUUMO] as const;
export type SpaceType = typeof spaceTypes[number];

export class SpaceModel extends BaseModel {
    id: number;
    name: string;
    status: number;
    language: string;
    timeZone: string;
    managedBy?: number;
    spaceType: SpaceType;
    countOfMembers: number;

    clear(): void {
        this.id = 0;
        this.name = '';
        this.status = 0;
        this.language = '';
        this.timeZone = '';
        this.managedBy = undefined;
        this.spaceType = SPACE_TYPE_NO;
        this.countOfMembers = 0;
    }
}
